export default __webpack_public_path__ + "static/beneficios-2-d9d52fc0693fa4d6e4efd2fed3706ffe.jpg";